import React, { PropTypes, Component } from 'react';
import Notification from './Notification';
import { loadprofileentity, updateprofileentity } from '../actions/WebsiteLoadCreator';
import { connectToStores } from 'fluxible/addons';
import ProfileReview from './ProfileReview';
var Rating = require('./Rating');
var cookie = require('react-cookie');
var sha1 = require('sha1');

class Profile extends Component {
  static propTypes = {
    entities: PropTypes.array.isRequired
  }

  static defaultProps = {
    entities: []
  }

  static contextTypes = {
    executeAction: React.PropTypes.func
  }
  componentDidMount() {
    var response = {};
    response.id = cookie.load('id', true);
    this.context.executeAction(loadprofileentity, response);
    $(".whirly-loader").css('visibility', 'hidden');
  }
  setlocation() {
    if (this.props.data.profile.length != 0) {
      if (this.props.data.profile[0].city === null) {
        $.get("http://ipinfo.io", function(response) {
          $("#location").html(response.city + ", " + response.region);
        }, "jsonp");
      } else {
        return this.props.data.profile[0].city;
      }
    }
  }
  setProfilePic() {
    if (this.props.data.profile.length != 0) {
      if (cookie.load('logged_in', true) === "1") {
        if (this.props.data.profile[0].profileimage != null) {
          return this.props.data.profile[0].profileimage;
        } else {
          return 'http://graph.facebook.com/undefined/picture';
        }
      } else if (cookie.load('logged_in', true) === "2") {
        return 'http://graph.facebook.com/' + cookie.load('id', true) + '/picture';
      }
    }
  }
  uploadimage(type) {
    $("#" + type.name + "image").click();
    $("#" + type.name + "image").on('change', function() {
      var file = document.getElementById(type.name + "image").files[0];
      var name = cookie.load('id', true) + "_" + type.name + ".png";
      if (!file)
        return;
      this.sign_request(file, name, function(response) {
        this.upload(file, response.signed_request, response.url, function() {
          if (type.name === "profile") {
            var response = {};
            response.id = cookie.load('id', true);
            response.folink_username = $('.profile-title').text();
            response.user_description = $('.profile-description').text();
            response.profileimage = 'https://k-s3bkp.s3.eu-west-2.amazonaws.com/folink/UserProfile/' + cookie.load('id', true) + '/' + cookie.load('id', true) + '_profile.png';
            this.context.executeAction(updateprofileentity, response);
          }
          $(".whirly-loader").css('visibility', 'visible');
          location.reload();
        }.bind(this));
      }.bind(this));
    }.bind(this));
  }

  upload(file, signed_request, url, done) {
    var xhr = new XMLHttpRequest();
    xhr.open("PUT", signed_request);
    xhr.setRequestHeader('x-amz-acl', 'public-read');
    xhr.onload = function() {
      if (xhr.status === 200) {
        done();
      }
    }
    xhr.send(file);
  }

  sign_request(file, name, done) {
    var xhr = new XMLHttpRequest();
    var folder = cookie.load('id', true);
    xhr.open("GET", "/sign?file_folder=" + folder + "&file_name=" + name + "&file_type=" + file.type);

    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var response = JSON.parse(xhr.responseText);
        done(response);
      }
    }

    xhr.send();
  }
  updateprofile() {
    var response = {};
    response.id = cookie.load('id', true);
    response.folink_username = $('.profile-title').text();
    response.userlocation = $('#location').text();
    response.user_description = $('.profile-description').text();
    response.profileimage = $('.profile-img').attr('src');
    this.context.executeAction(updateprofileentity, response);
  }
  editUsername() {
    $('.profileName').css('display', 'none');
    $('.editable-name').css('display', 'block');
  }
  editUserdescription() {
    $('.profileDescription').css('display', 'none');
    $('.editable-description').css('display', 'block');
  }
  saveNameChanges() {
    var username = $('#profile-updatename').val();
    var location = $('#profile-updatelocation').val();
    var date = new Date();
    cookie.save('username=' + username + ';expires=' + date + 'httpOnly=false');
    $('.profile-title').text(username);
    $('#location').text(location);
    this.updateprofile();
    $('#profile-updatename').text();
    $('#profile-updatelocation').text();
    $('.editable-name').css('display', 'none');
    $('.profileName').css('display', 'block');
  }
  saveDescChanges() {
    var userdesc = $('#profile-updatedesc').val();
    $('.profile-description').text(userdesc);
    this.updateprofile();
    $('#profile-updatedesc').text();
    $('.editable-description').css('display', 'none');
    $('.profileDescription').css('display', 'block');
  }
  cancelNameChanges() {
    $('.editable-name').css('display', 'none');
    $('.profileName').css('display', 'block');
  }
  cancelDescChanges() {
    $('.editable-description').css('display', 'none');
    $('.profileDescription').css('display', 'block');
  }
  render() {
    var profile = this.props.data.profile;
    var currentPage = 10;
    var paginationlength = Math.ceil(profile.length / 10);
    var indents = [];
    var pages = 0;
    for (var i = 0; i < paginationlength; i++) {
      pages++;
      indents.push({
        id: pages
      });
    }
    var fblogin = profile[0] ? profile[0].is_fb_login : '';
    var user_description = profile[0] ? profile[0].user_description : '';
    return (
      <div id="content">
        <div className='container-fluid first-section' style={ { "height": "65vh" } }>
          <img id="profile-img" className="profile-container-img profile-img cover-img" src={ 'https://k-s3bkp.s3.eu-west-2.amazonaws.com/folink/UserProfile/' + cookie.load('id', true) + '/' + cookie.load('id', true) + '_cover.png' } alt="" />
          <div className="upload-cover-container">
            <div className="upload-button upload-coverbutton" onClick={ this.uploadimage.bind(this, {
                                                                          name: "cover"
                                                                        }) }>
              <i className="sprite-white sprite-Camera cover-icon"></i>
              <a>Update cover photo</a>
            </div>
          </div>
          <input className="file-upload" id="coverimage" type="file" accept="image/*" />
        </div>
        <div className='container-fluid second-section'>
          <div className='row-fluid profile-content clearfix'>
            <div className="col-md-3 profile-img-cont" style={ { "margin-top": "-10em" } }>
              <div className="profile-image-container">
                <img id="profile-img" style={ { "margin": "0", "width": "100%" } } className="profile-container-img profile-img" src={ this.setProfilePic() } alt="" />
                <div className="upload-container">
                  <div className="upload-button" onClick={ this.uploadimage.bind(this, {
                                                             name: "profile"
                                                           }) }>
                    <i className="sprite-white sprite-Camera"></i> <a>Update profile photo</a>
                  </div>
                </div>
                <input className="file-upload" id="profileimage" type="file" accept="image/*" />
              </div>
            </div>
            <div className="col-md-6">
              <div>
                <div className="profile-name-container">
                  <div className="ProfileName_EditContainer">
                    <div className="profileName">
                      <span className="profile-title">{ cookie.load('username', true) }</span>
                      { (4 < profile.folink_user_reviewer_rank) && (
                        <div className="reviewer-status">Expert</div>
                        ) }
                      <div className="reviewer-location" style={ { "padding": "1em" } }>
                        <i className="sprite-white sprite-Location" style={ { "margin-right": "0em", "margin-top": "-1em" } }></i><span id="location">{ this.setlocation() }</span>
                      </div>
                      <i className="sprite-white sprite-Compose compose-name" onClick={ this.editUsername.bind(this) } style={ { "float": "right" } }></i>
                    </div>
                    <div className="editable-name">
                      <input type="text" id="profile-updatename" placeholder="Update Ur profile Name.." size="35" />
                      <input type="text" id="profile-updatelocation" placeholder="Update Ur Location.." size="35" />
                      <div style={ { "float": "left" } }>
                        <div className="btn-edit" id="user_name" onClick={ this.saveNameChanges.bind(this) }>save</div>
                        <div className="btn-edit" onClick={ this.cancelNameChanges.bind(this) }>cancel</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="profile-desc-container">
                  <div className="ProfileDescription_EditContainer">
                    <div className="profileDescription">
                      <div className="profile-description">
                        { user_description }
                      </div>
                      <i className="sprite-white sprite-Compose compose-desc" onClick={ this.editUserdescription.bind(this) } style={ { "float": "right" } }></i>
                    </div>
                    <div className="editable-description">
                      <input type="textarea" id="profile-updatedesc" placeholder="Write something about Urself.." size="100" />
                      <div style={ { "float": "left" } }>
                        <div className="btn-edit" id="user_desc" onClick={ this.saveDescChanges.bind(this) }>save</div>
                        <div className="btn-edit" onClick={ this.cancelDescChanges.bind(this) }>cancel</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="profile-review-title">
                  <div className="profile-review-count">
                    { profile[0] ? profile[0].review_description ? profile.length : 0 : 'null' } reviews</div>
                </div>
                { (profile.length != 0) && (<div className="profile-review-description">
                                              <ProfileReview entities={ profile } />
                                            </div>) }
              </div>
            </div>
            <div className="col-md-3 profilefollow-container">
              <div className="profile-connector">
                <div>
                  <div className="profileconnector-detail">
                    <div className="profileconnector-title">How you're connected</div>
                    <div>
                      <img id="profile-img" style={ { "margin": "0", "width": "50%", "padding": "1em" } } className="profile-img" src={ this.setProfilePic() } alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }

}
Profile.defaultProps = {
  logindata: {}
};

Profile = connectToStores(Profile, ['LoginStore'], (stores, props) => {
  return {
    logindata: stores.LoginStore.get()
  };

});
module.exports = Profile;



// WEBPACK FOOTER //
// ./src/components/Profile.js